<script>
import { mapActions } from "vuex";

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    image: null,
  }),

  /*created() {
    this.image = this.url;
  },*/
  computed: {
    getPhoto() {
      return this.url;
    },
  },

  methods: {
    ...mapActions("admin-olimpiada2024", ["GET_FILE_API"]),
  },
};
</script>

<template>
  <div v-if="url">
    <img class="cursor-pointer" v-viewer :src="getPhoto" alt="" />
  </div>
  <v-skeleton-loader v-else class="h-100 w-100" type="image" />
</template>

<style lang="scss" scoped>
img {
  height: 250px;
}
</style>
